
import { timeFormat } from "@/utils/time";
import dict from "@/config";


export const getAlbumColumns = () => {
	return [
		{
			title: "学生姓名",
			dataIndex: "studentName",
			align: "center",
			customRender: (text, row) => {
				if (row.rowSpan) {
					return {
						children: text,
						attrs: { rowSpan: row.rowSpan, align: "center" },
					};
				}
				return {
					children: text,
					attrs: { rowSpan: 0, align: "center" },
				};
			},
		},
		{
			title: "手册名称",
			dataIndex: "title",
			align: "center",
			width: 300,
			scopedSlots: { customRender: "albumName" },
		},
		{
			title: "手册状态",
			dataIndex: "status",
			align: "center",
			customCell: (record) => {
				if (!record.status || record.status === "INITIALIZED") {
					return { class: "ALBUM_STATUS_INITIALIZED" };
				}
				return { class: "ALBUM_STATUS_FINALIZED" };
			},
			customRender: (text) => {
				if (!text) {
					return "--";
				}
				return `● ${dict.ALBUM_STATUS[text] || "已定稿"}`;
			},
		},
		// {
		// 	title: "支付状态",
		// 	dataIndex: "status",
		// 	align: "center",
		// 	customRender: (text, record) => {
		// 		return record.stat.student_count;
		// 	},
		// },
		// {
		// 	title: "创建时间",
		// 	dataIndex: "create_time",
		// 	align: "center",
		// 	customRender: (text) => {
		// 		return text ? timeFormat(text, "YYYY-MM-DD HH:mm") : "--";
		// 	},
		// },
		{
			title: "最后修改时间",
			dataIndex: "update_time",
			align: "center",
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD HH:mm") : "--";
			},
		},
		{
			title: "电子版生成状态",
			dataIndex: "albumStatus",
			align: "center",
			// scopedSlots: { customRender: "albumStatus" },
			customCell: (record) => {
				if (["INITIALIZED", "FINALIZED"].includes(record.status)) {
					return { class: "ALBUM_STATUS_INITIALIZED" };
				}
				return { class: `ALBUM_STATUS_${record.status}` };
			},
			customRender: (text, record) => {
				return `${dict.ALBUM_DIGTAL_STATUS[record.status] || "未生成电子版"}`;
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			scopedSlots: { customRender: "operation" },
		},
	];
};
export const getAlbumTempColumns = () => {
	return [
		{
			title: "模板名称",
			dataIndex: "title",
			align: "center",
			width: 350,
			scopedSlots: { customRender: "albumName" },
		},
		{
			title: "手册状态",
			dataIndex: "is_active",
			align: "center",
			customCell: (record) => {
				if (record.is_active) {
					return { class: "success-color" };
				}
				return { class: "grey-color" };
			},
			customRender: (text) => {
				return text ? "● 使用中" : "已失效";
			},
		},
		{
			title: "创建时间",
			dataIndex: "create_time",
			align: "center",
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD HH:mm") : "--";
			},
		},
		{
			title: "最后修改时间",
			dataIndex: "update_time",
			align: "center",
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD HH:mm") : "--";
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			scopedSlots: { customRender: "operation" },
		},
	];
};

export default {
	getAlbumColumns
};
